// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Styles
import './PopupPanelAsideSection.scss';

const PopupPanelAsideSection = ({ children, className, asideChildren, wrapper = <div /> }) => (
    <section className={classNames('PopupPanelAsideSection', className, { 'has-aside': !!asideChildren })}>
        {React.cloneElement(
            wrapper,
            null,
            <div className="panel">
                {asideChildren && <aside>{asideChildren}</aside>}
                <div className="content">{children}</div>
            </div>,
        )}
    </section>
);

PopupPanelAsideSection.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]),
    asideChildren: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]),
    wrapper: PropTypes.node,
    className: PropTypes.string,
};

export default PopupPanelAsideSection;
